import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Util } from '@libs/utilities/util';

import { NgAbstractInputComponent } from '../../shared/inputs.abstract';
import { EnumNgButtonCheckboxSize, INgCheckboxButtonGroup, INgCheckboxButtonGroupOptions } from './checkbox-button-group.interface';


@Component({
    selector: 'ng-checkbox-button-group',
    templateUrl: './checkbox-button-group.component.html',
    styleUrls: ['./checkbox-button-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: NgCheckboxButtonGroupComponent,
            multi: true
        }
    ],
    standalone: false
})
export class NgCheckboxButtonGroupComponent extends NgAbstractInputComponent<string[]> implements OnChanges, ControlValueAccessor {

	//** Input properties */
	@Input() size			: EnumNgButtonCheckboxSize | null	   = null;
	@Input() options		: INgCheckboxButtonGroupOptions | null = null;
	@Input() checkboxGroup 	: Array<INgCheckboxButtonGroup[]>	   = [];

	//** Helper variables */
	buttonSize!	: string;

	constructor() {
		super('button-checkbox');
	}


	/**------------------------------------------------------
	 * Live Cycle Hooks
	 */
	ngOnChanges(): void {

		// update object and button size
		this.buttonSize = this.size ? `btn-group-${this.size}` : `btn-group`;
	}


	/**------------------------------------------------------
	 * Control Value Accessor Functions
	 */
	override writeValue(value: string[]): void {

		//0 - was any value defined?
		if (!value) return;

		//1 - assign the values
		this.value = value;
		for (const checkboxes of this.checkboxGroup) {

			//a. do we have any checkboxes?
			if (Util.Array.isEmpty(checkboxes)) continue;

			//b. set the values
			for (const checkbox of checkboxes) {
				checkbox.selected = value.includes(checkbox.code);
			}
		}
	}


	/**------------------------------------------------------
	 * User Actions
	 */
	updateSelected(): void {

		//0 - get the selected values
		const value: string[] = [];
		for (const checkboxes of this.checkboxGroup) {
			value.push(...checkboxes.filter((checkboxGroup: INgCheckboxButtonGroup) => checkboxGroup.selected).map((checkboxGroup: INgCheckboxButtonGroup) => checkboxGroup.code));
		}

		//1 - trigger the change with the new value
		this.value = value;
		this.onChange(this.value);
	}
}
